<template>
<div class="chapter">
<div class="inner_page">
<a id="page_vii"></a>
<h1 class="toc-title"><span class="bold">Contents</span></h1>
<h2 class="toc"><a href="#/xhtml/05_Acknowledgements">Acknowledgements</a></h2>
<h2 class="toc"><a href="#/xhtml/06_Glossary">Abbreviations and Glossary</a></h2>
<h2 class="tocb"><a href="#/xhtml/07_Introduction">Introduction</a></h2>
<h2 class="tocc"><a href="#/xhtml/08_Chapter01"><span class="tocc">Chapter 1</span> Rudolf Hess: The Uninvited Guest</a></h2>
<h2 class="tocc"><span href="#/xhtml/09_Chapter02" title="Link target outside of Sample"><span class="tocc">Chapter 2</span> Nazi Against Hitler: Count Wolf-Heinrich von Helldorf</span></h2>
<h2 class="tocc"><span href="#/xhtml/10_Chapter03" title="Link target outside of Sample"><span class="tocc">Chapter 3</span> New Beginning and Crucifix Struggles: Reviews</span></h2>
<h2 class="tocc"><span href="#/xhtml/11_Chapter04" title="Link target outside of Sample"><span class="tocc">Chapter 4</span> The Nazi Dissolution of the Monasteries: A Bavarian Case Study</span></h2>
<h2 class="tocc"><span href="#/xhtml/12_Chapter05" title="Link target outside of Sample"><span class="tocc">Chapter 5</span> Hugh Trevor-Roper and <em class="italic">The Last Days of Hitler</em></span></h2>
<h2 class="tocc"><span href="#/xhtml/13_Chapter06" title="Link target outside of Sample"><span class="tocc">Chapter 6</span> Hugh Trevor-Roper’s Special Missions in Germany</span></h2>
<h2 class="toct"><span href="#/xhtml/14_Bibliography" title="Link target outside of Sample">Bibliography</span></h2>
<h2 class="toc"><span href="#/xhtml/15_Endnotes" title="Link target outside of Sample">Endnotes</span></h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?ef1651e4